export const planStyles = {
  container: {
    padding: '20px',
  },
};
